import {format, isToday, isYesterday, isThisYear, isValid} from 'date-fns'

/**
 *
 * @param date - The date to format
 * @description - Formats a date into a more readable string. Meant to be used as a unique identifier in places such as
 * comments. Inspired by the equivalent aria_label_date available in our Ruby files.
 *
 * There is a known caveat with this approach:
 * - If the user keeps a tab open for a long time, the text will become outdated.
 * - The format is different from our relative-time element (which uses relative minute unites and auto-updates as time passes).
 * These caveats are acceptable trade-offs for the use case of this function (serving as a unique identifier in comments).
 * See: https://www.loom.com/share/0bfa364077aa447d9eb199b12e51672e?sid=c9b0e7fd-6007-4fa0-89cb-bb733a895d9b
 * @returns - A string that describes the date and time, in increasing verbosity.
 */
export function ariaLabelDate(date: Date) {
  if (!isValid(date)) return ''

  const timeString = format(date, 'h:mm a')

  if (isToday(date)) {
    return `${timeString} today`
  } else if (isYesterday(date)) {
    return `${timeString} yesterday`
  } else if (isThisYear(date)) {
    return `${timeString} on ${format(date, 'MMMM d')}`
  } else {
    return `${timeString} on ${format(date, 'MMMM d, yyyy')}`
  }
}
